import React from "react";

import { Button, Statistic, Descriptions } from "antd";

import { UserOutlined, ContainerOutlined } from "@ant-design/icons";

import DateTimeJob from "../../status/datetime";
import { getStatusColor } from "../../status";

import StatisticAmount from "../../../../core/components/widget/amountInline/statistic";

import PropTypes from "prop-types";

const propTypes = {
    forVendor: PropTypes.bool,
    job: PropTypes.object.isRequired,
    //buttonLabel: PropTypes.string,
    //onUpload: PropTypes.func.isRequired,
};

const defaultProps = {
    forVendor: false,
    job: {},
};

const Content = ({ children, extra }) => {
    return (
        <div className="content">
            {/*<img src="https://icon-library.com/images/translate-icon-png/translate-icon-png-9.jpg" alt="content" width="100px"/>*/}
            <div className="main">{children}</div>
            <div className="extra">{extra}</div>
        </div>
    );
};

const extraContent = (props) => (
    <div
        style={{
            display: "flex",
            width: "max-content",
            justifyContent: "flex-end",
        }}
    >
        <Statistic
            title="Status"
            value={props.job.status}
            style={{ marginRight: 32 }}
            valueStyle={{ color: getStatusColor(props.job.status) }}
        />

        {!props.forVendor && (
            <StatisticAmount
                title="Price"
                prefix={props.job.total_to_receive_type}
                value={props.job.total_to_receive_value}
            />
        )}
    </div>
);

const JobDetailDTO = (props) => {
    const { job, column } = props;

    return (
        <>
            <Content extra={extraContent(props)}>
                <Descriptions size="small" column={column != null ? column : 2}>
                    <Descriptions.Item label="Name"> {job.name} </Descriptions.Item>
                    <Descriptions.Item label="E-ID"> {job.eid} </Descriptions.Item>
                    <Descriptions.Item label="Manager">
                        <Button size="small" type="dashed">
                            {" "}
                            <UserOutlined />
                            {job.manager?.name}
                        </Button>
                    </Descriptions.Item>

                    <Descriptions.Item label="Project">
                        <Button size="small" type="dashed">
                            {" "}
                            <ContainerOutlined />
                            {job.project?.name}
                        </Button>
                    </Descriptions.Item>
                    <Descriptions.Item label="Point Of Sale">
                        <Button size="small" type="dashed">
                            {" "}
                            <ContainerOutlined />
                            {job.point_of_sale?.name}
                            {job.component ? " (" + job.component.name + ")" : ""}
                        </Button>
                    </Descriptions.Item>

                    {!props.forVendor && <Descriptions.Item label="Receivable Code">{job.code}</Descriptions.Item>}
                    {!props.forVendor && (
                        <Descriptions.Item label="Client Deadline At">
                            <DateTimeJob value={job.client_deadline_at} status={job.status} />
                        </Descriptions.Item>
                    )}
                    <Descriptions.Item label="Notes"> {job.notes} </Descriptions.Item>
                </Descriptions>
            </Content>
        </>
    );
};

JobDetailDTO.propTypes = propTypes;
JobDetailDTO.defaultProps = defaultProps;

export default JobDetailDTO;
